import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeReplenishmentSettingsMutationVariables = Types.Exact<{
  input: Types.MergeReplenishmentSettingsInput;
}>;


export type MergeReplenishmentSettingsMutation = { __typename?: 'Mutation', mergeReplenishmentSettings: { __typename?: 'ReplenishmentSettingsPayload', state?: { __typename?: 'ReplenishmentSettingsStateData', tenantId: string, forwardDaysLastYear: number, trailingDaysThisYear: number, defaultTargetWeeksOfSupply: number, inventoryTrailingDays: number, minUsableDaysThreshold?: number | null, roundToFullCart: boolean, sellThroughThreshold?: number | null, shipmentIncrement: number, allocationReservationPercentage: number, allocationType: Types.AllocationType, allocationPriorities: Array<Types.AllocationPriorityDimension>, updatedAt: Types.TDateISO, updatedBy: string, programWindowConfigs: Array<{ __typename?: 'ProgramWindowConfigStateData', program: string, minUsableDaysThreshold?: number | null, sellThroughThreshold?: number | null, trailingDaysThisYear?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MergeReplenishmentSettingsDocument = new TypedDocumentString(`
    mutation MergeReplenishmentSettings($input: MergeReplenishmentSettingsInput!) {
  mergeReplenishmentSettings(input: $input) {
    state {
      ...ReplenishmentSettingsDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ReplenishmentSettingsDetails on ReplenishmentSettingsStateData {
  tenantId
  forwardDaysLastYear
  trailingDaysThisYear
  defaultTargetWeeksOfSupply
  inventoryTrailingDays
  minUsableDaysThreshold
  programWindowConfigs {
    program
    minUsableDaysThreshold
    sellThroughThreshold
    trailingDaysThisYear
  }
  roundToFullCart
  sellThroughThreshold
  shipmentIncrement
  allocationReservationPercentage
  allocationType
  allocationPriorities
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeReplenishmentSettings: build.mutation<MergeReplenishmentSettingsMutation, MergeReplenishmentSettingsMutationVariables>({
      query: (variables) => ({ document: MergeReplenishmentSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeReplenishmentSettingsMutation } = injectedRtkApi;
